import { z } from 'zod'

export const authTokenSchema = z.object({
  token: z.string(),
  refresh_token: z.string()
})

export type AuthToken = z.infer<typeof authTokenSchema>
